// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nonbackground .ivu-table,.nonbackground .ivu-table td{background-color:rgba(20,20,20,0);border-bottom:none}", ""]);
// Exports
module.exports = exports;
